module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-list', {
    staticClass: "md-double-line"
  }, _vm._l((_vm.getReversedArticles), function(article, index) {
    return _c('md-list-item', {
      key: index
    }, [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_c('a', {
      attrs: {
        "href": article.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(article.title))])]), _vm._v(" "), (article.genre === 'SetDance') ? _c('span', {
      key: "articleSetDance",
      staticClass: "md-primary type-of-event"
    }, [_vm._v("セットダンス")]) : (article.genre === 'SeanNos') ? _c('span', {
      key: "articleSeanNos",
      staticClass: "md-accent type-of-event"
    }, [_vm._v("シャンノース")]) : (article.genre === 'CeiliDance') ? _c('span', {
      key: "articleSeanNos",
      staticClass: "md-accent type-of-event"
    }, [_vm._v("ケーリーダンス")]) : (article.genre === 'OldStyleStepDance') ? _c('span', {
      key: "articleSeanNos",
      staticClass: "md-accent type-of-event"
    }, [_vm._v("オールドスタイル")]) : (article.genre === 'ModernStyleStepDance') ? _c('span', {
      key: "articleSeanNos",
      staticClass: "md-accent type-of-event"
    }, [_vm._v("モダンスタイル")]) : (article.genre === 'Others') ? _c('span', {
      key: "articleOthers",
      staticClass: "md-primary type-of-event"
    }, [_vm._v("その他")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(article.description) + " by " + _vm._s(article.writers) + "\n        ")])]), _vm._v(" "), _c('md-divider')], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06de8943","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AllArticles.vue
// module id = 326
// module chunks = 1